<script lang="ts">
  import {getContext, onDestroy} from 'svelte';

  import * as Store from '@/store';

  import Dialog from '@/components/dialog/Dialog.svelte';
  import VideoPlayer from '@/components/video-snapshot/VideoPlayer.svelte';
  import viddialogStore from './viddialog-store';

  // export let isVidImgDialogOpen = true;
  import {triggerOnSeek} from '@components';
  import editorInstance from '@/lib/editor/editor';
  import {httpClient} from '@/utils/http-client';
  import {removingBg} from './loading-store';
  import Swal from 'sweetalert2';
  // export let videoFilesLength = 0;

  const simpleModal: {open: Function; close: Function} = getContext('simple-modal');
  let play: boolean = false;
  let hideSwitch: string = 'hidden';
  let remBg: boolean = false;

  // viddialogStore.set(true)

  const onSeek = (e: CustomEvent) => {
    triggerOnSeek(e.detail.time);
  };

  var canvas: HTMLCanvasElement = document.createElement('canvas');

  function snap(): void {
    var video: HTMLVideoElement | null = document.getElementById('videoseek') as HTMLVideoElement;
    var context: CanvasRenderingContext2D | null = canvas.getContext('2d');

    if (!video) {
      console.log("Video element 'videoseek' not found");
      return;
    }

    if (!context) {
      console.log('Canvas context not supported');
      return;
    }

    var w: number, h: number, ratio: number;
    ratio = video.videoWidth / video.videoHeight;
    w = video.videoWidth - 100;
    h = parseInt(String(w / ratio), 10);

    canvas.width = w;
    canvas.height = h;

    context.fillRect(0, 0, w, h);
    context.drawImage(video, 0, 0, w, h);

    var src = canvas.toDataURL('image/jpeg');
    // Store.thumbnail.set({ ...Store.thumbnail, snapshot: src });
    Store.thumbnail.setSnapshot(src);

    editorInstance.insertPastorPic(src);
    // isVidImgDialogOpen = false
  }

  async function insertSnapshot() {
    removingBg.set(true);

    var video: HTMLVideoElement | null = document.getElementById('videoseek') as HTMLVideoElement;
    var context: CanvasRenderingContext2D | null = canvas.getContext('2d');

    if (!video) {
      console.log("Video element 'videoseek' not found");
      return;
    }

    if (!context) {
      console.log('Canvas context not supported');
      return;
    }

    var w: number, h: number, ratio: number;
    ratio = video.videoWidth / video.videoHeight;
    w = video.videoWidth - 100;
    h = parseInt(String(w / ratio), 10);

    canvas.width = w;
    canvas.height = h;

    context.fillRect(0, 0, w, h);
    context.drawImage(video, 0, 0, w, h);

    var src = canvas.toDataURL('image/jpeg');
    Store.thumbnail.setSnapshot(src);

    editorInstance.insertPastorPic(src);
    viddialogStore.set(false);
    removingBg.set(false);

    const blob: Blob = await new Promise<Blob>(resolve => canvas.toBlob(resolve as BlobCallback, 'image/jpeg'));
    const formData = new FormData();
    formData.append('name', 'videosnapshot'); // Add the name field
    formData.append('file', blob, 'snapshot.jpg');
    formData.append('removeBg', 'false');

    try {
      const response = await httpClient.post('/image/snapshot', formData);
      const result = response.data;
      if (result?.success && result?.file?.publicUrl) {
        editorInstance.insertPastorPic(result?.file?.publicUrl);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed to remove background',
          text: 'It looks like the remove background feature didn’t work for this moment. Try selecting a different moment in the video. If the issue continues, please contact us'
        });
      }
    } catch (error) {
      console.error('Upload failed:', error);
      Swal.fire({
        icon: 'error',
        title: 'Failed to remove background',
        text: 'It looks like the remove background feature didn’t work for this moment. Try selecting a different moment in the video. If the issue continues, please contact us'
      });
    }
  }

  async function insertNoBg() {
    const snapshotElement: HTMLImageElement | null = document.getElementById('snapshot') as HTMLImageElement;
    if (snapshotElement) {
      editorInstance.insertPastorPic(snapshotElement.src);
      viddialogStore.set(false);
    }
  }
  async function removeBg() {
    removingBg.set(true);
    var video: HTMLVideoElement | null = document.getElementById('videoseek') as HTMLVideoElement;
    var context: CanvasRenderingContext2D | null = canvas.getContext('2d');

    if (!video) {
      console.log("Video element 'videoseek' not found");
      return;
    }

    if (!context) {
      console.log('Canvas context not supported');
      return;
    }

    var w: number, h: number, ratio: number;
    ratio = video.videoWidth / video.videoHeight;
    w = video.videoWidth - 100;
    h = parseInt(String(w / ratio), 10);

    canvas.width = w;
    canvas.height = h;

    context.fillRect(0, 0, w, h);
    context.drawImage(video, 0, 0, w, h);

    var src = canvas.toDataURL('image/jpeg');
    Store.thumbnail.setSnapshot(src);

    const blob: Blob = await new Promise<Blob>(resolve => canvas.toBlob(resolve as BlobCallback, 'image/jpeg'));
    const formData = new FormData();
    formData.append('name', 'videosnapshot'); // Add the name field
    formData.append('file', blob, 'snapshot.jpg');
    formData.append('removeBg', 'true');

    try {
      const response = await httpClient.post('/image/snapshot', formData);
      const result = response.data;
      // var result = {success: true, file: {publicUrl: "https://storage.googleapis.com/sermonshots-dev-bucket/uploads%2F228.png"}};
      if (result?.success) {
        const snapshotElement: HTMLImageElement | null = document.getElementById('snapshot') as HTMLImageElement;
        if (snapshotElement) {
          snapshotElement.src = result?.file?.publicUrl;
          // snapshotElement.style.display = "block";
          setTimeout(() => {
            // var naturalH = snapshotElement.naturalHeight;
            // var naturalW = snapshotElement.naturalWidth;
            // var ratio = naturalH / naturalW;
            // var newW = snapshotElement.clientHeight / ratio;
            // snapshotElement.style.width = newW + "px";
          }, 100);
          hideSwitch = '';
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed to remove background',
          text: 'It looks like the remove background feature didn’t work for this moment. Try selecting a different moment in the video. If the issue continues, please contact us'
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed to remove background',
        text: 'It looks like the remove background feature didn’t work for this moment. Try selecting a different moment in the video. If the issue continues, please contact us'
      });
      console.error('Upload failed:', error);
    }
    // isVidImgDialogOpen = false
    removingBg.set(false);
  }
  onDestroy(() => {});
</script>

<Dialog bind:isDialogOpen={$viddialogStore} useIfShow={true}>
  <div class="pointer-events-none flex h-full w-full items-center justify-center">
    <form
      on:submit|preventDefault={() => {}}
      class="max-w-[1100px ] pointer-events-auto mx-4 h-auto w-3/4 min-w-[280px] rounded-2xl border border-gray-300 bg-white shadow-lg dark:border-zinc-600 dark:bg-zinc-700"
    >
      <div class="flex flex-row p-6 text-black dark:text-zinc-200">
        <div class="flex w-full flex-col">
          <div class="flex items-start justify-between pb-4">
            <h1 class="w-full text-center text-3xl font-bold">Take a Snapshot</h1>
            <button
              on:click={() => viddialogStore.set(false)}
              class="ml-4 rounded-lg px-2 hover:bg-zinc-100 dark:hover:bg-zinc-600"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
          </div>
          <p class="mx-auto w-3/4 text-center text-dark-400">
            Find the moment in the sermon that you want to capture the speaker. Simply find the moment and click the
            "Snapshot" button. For social media, you typically want to find a moment when the pastor is being
            expressive.
          </p>
        </div>
      </div>
      <hr class="border-t border-t-gray-300 dark:border-zinc-600" />
      <div class="grid p-6">
        <div class="py-2">
          <VideoPlayer
            bind:play
            on:video-seek={onSeek}
            on:adjust-seek={onSeek}
            {insertSnapshot}
            {removeBg}
            {insertNoBg}
            {hideSwitch}
          />
        </div>
      </div>
      <hr class="border-t border-t-gray-300 dark:border-zinc-600" />
    </form>
  </div>
</Dialog>
